export type ChatTextProps = { backgroundColor?: string; text: string[] };
export type ChatArtifactPreviewProps = {
  artifactName:
    | 'ActivityDiary'
    | 'BingeEatingMyPlan'
    | 'BreathHolding'
    | 'CopingCards'
    | 'CrisisFramework'
    | 'EatingLog'
    | 'EditEatingSchedule'
    | 'HopeKit'
    | 'Hyperventilation'
    | 'MyPlan'
    | 'MyPlanReview'
    | 'MyProgress'
    | 'QuizSet'
    | 'Relaxation'
    | 'RiskCurve'
    | 'SleepDiary'
    | 'SoloMyPlan'
    | 'SoloRiskCurve'
    | 'SoloSuicideMode'
    | 'StressSensitivityAssessment'
    | 'SuicideMode'
    | 'ThoughtDiary'
    | 'WordPairing';
  linkText: string;
  params?: object;
  testID?: string;
};
export type ChatTableProps = { data: string[][]; markdown?: boolean };
export type ChatAssetProps = { uri: string; linkText?: string };
